import { Tags } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";

/**
 * Value shape for {@link TagCell}.
 */
export interface TagCellValue {
  /** Text shown inside the tag. */
  text: string;
  /** Tag background color. */
  backgroundColor?: string;
  /** Tag text (foreground) color. */
  foregroundColor?: string;
}

interface TagCellProps {
  value: TagCellValue;
}

/**
 * Table cell that renders an oasis {@link Tags} chip from cell value props.
 *
 * @param props - Cell value with text and optional background/foreground colors
 * @returns Tag chip cell
 */
export const TagCell: React.FC<TagCellProps> = ({ value }) => {
  const text = value?.text ?? "";
  const backgroundColor = value?.backgroundColor ?? "#F5F5F5";
  const foregroundColor = value?.foregroundColor ?? "#0F0F0F";

  return (
    <div className="table-cell-tag w-fit" onClick={(e) => e.stopPropagation()}>
      <Tags
        label={text}
        backgroundColor={backgroundColor}
        textColor={foregroundColor}
        shouldTruncate
      />
    </div>
  );
};

export default TagCell;
